import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import { resultsConfig } from '@Constants/Results';
import SubstanceHelper from '@Components/Results/services/substance-helper.factory';
import SubstanceQuantitativeData from '@Components/Results/substances/tables/quantitative/SubstanceQuantitativeData';
import SubstanceQualitativeData from '@Components/Results/substances/tables/qualitative/SubstanceQualitativeData';
import store from '@Store';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import * as BioData from '@Services/BioData';
import Catalyst from '@Services/Catalyst';

const initialItemsAmount = resultsConfig.INITIAL_ITEMS_AMOUNT.substanceBio;

export default class SubstanceBioData extends React.PureComponent {
  constructor(props) {
    super(props);

    const {
      fact,
      fact: { bioData, name, id, columnsViewedByDefault },
      substanceId,
    } = props;

    const categoryName = fact.name || fact.id;
    this.quan = bioData ? BioData.changeQuanDataFormat(categoryName, bioData.quan) : undefined;
    this.qual = bioData?.qual;
    this.uniqueId = `biodata-${name || id}`;
    this.columnsViewedByDefault = columnsViewedByDefault;

    const retrieveData = (type) => {
      const resultName = getValueByNs(bioData, `${type}.resultName`, false);
      if (resultName) {
        return SubstanceHelper.retrieveBioContent.bind(null, type, categoryName, bioData.databaseId, resultName);
      }
      return () => {};
    };
    const trackViewedData = (type) => {
      const mode = `showMoreBio${type}`;
      // eslint-disable-next-line no-shadow, func-names
      return function (entities, type, title, firstItem, lastItem) {
        Catalyst.trackAmountOfViewedData(substanceId, entities, mode, title || categoryName, store.getState(), firstItem, lastItem);
      };
    };

    this.retrieveQuanData = retrieveData('quan');
    this.retrieveQualData = retrieveData('qual');
    this.trackQuanData = trackViewedData('quan');
    this.trackQualData = trackViewedData('qual');
  }

  render() {
    const { quan, qual, uniqueId, columnsViewedByDefault } = this;
    const { metadata, substanceId } = this.props;

    return (
      <>
        {quan && (
          <SubstanceQuantitativeData
            metadata={metadata}
            substanceId={substanceId}
            total={quan.count}
            data={quan.formatedData}
            uniqueId={uniqueId}
            retrieveData={this.retrieveQuanData}
            track={this.trackQuanData}
            showTitle
            initialItemsAmount={initialItemsAmount}
            columnsViewedByDefault={columnsViewedByDefault}
          />
        )}

        {qual && (
          <SubstanceQualitativeData
            metadata={metadata}
            total={qual.count}
            data={qual.data}
            uniqueId={uniqueId}
            retrieveData={this.retrieveQualData}
            track={this.trackQualData}
            showTitle
            initialItemsAmount={initialItemsAmount}
          />
        )}
      </>
    );
  }
}

SubstanceBioData.propTypes = {
  metadata: MetadataPropTypesShape,
  fact: PropTypes.shape({
    bioData: PropTypes.shape({
      quan: PropTypes.object,
      qual: PropTypes.object,
      databaseId: PropTypes.string,
    }),
    id: PropTypes.string,
    name: PropTypes.string,
    columnsViewedByDefault: PropTypes.array,
  }).isRequired,
  substanceId: PropTypes.string.isRequired,
};
